import SV from 'server-vars';
import { sessionStorage } from 'dibs-browser-storage';
import { getUserLang } from 'dibs-cookie-jar/exports/lang';
import { isDefaultLang } from 'dibs-intl/exports/languages';
import { isLocale, getBrowserLocale } from 'dibs-intl/exports/locales';
import { PAGE_TYPE } from 'dibs-constants/exports/pageTypes';
import { LANG_DISCREP_MODAL_DISPLAY_KEY } from '../../InternationalSiteNavigation/constants';

import { type Options } from '../types';

type Rule = {
    forceNotification?: boolean;
};

const BLOCKED_PAGE_TYPES = [
    PAGE_TYPE.NFT,
    PAGE_TYPE.NFT_COLLECTIONS,
    PAGE_TYPE.INTERIORS,
    PAGE_TYPE.DESIGN_FIRMS,
    PAGE_TYPE.DESIGNER_CONNECTION,
    PAGE_TYPE.PHOTOS,
    PAGE_TYPE.ANSWERS,
    PAGE_TYPE.APPLICATION_FORM,
    PAGE_TYPE.NOT_FOUND,
    PAGE_TYPE.NOT_AUTHORIZED,
];

const langDiscrepancyModalRule = async ({ forceNotification }: Rule): Promise<boolean> => {
    if (forceNotification) {
        return true;
    }

    if (sessionStorage.getItem(LANG_DISCREP_MODAL_DISPLAY_KEY)) {
        return false;
    }

    const preferredLanguage = getUserLang(document.cookie);

    if (preferredLanguage) {
        return false;
    }

    const locale = SV.get('locale');

    if (isDefaultLang(locale)) {
        return false;
    }

    const browserLocale = getBrowserLocale();

    if (!browserLocale || browserLocale === locale) {
        return false;
    }

    sessionStorage.setItem(LANG_DISCREP_MODAL_DISPLAY_KEY, true);

    return true;
};

export default [
    {
        name: 'intlLanguageDiscrepancyModal',
        rule: langDiscrepancyModalRule,
        blockedPageTypes: BLOCKED_PAGE_TYPES,
        action: (options: Options) => (): void => {
            const locale = getUserLang(document.cookie) || getBrowserLocale();

            if (!isLocale(locale)) {
                return;
            }

            import(
                /* webpackChunkName: "languageDiscrepancyModal" */
                './../../InternationalSiteNavigation/loadLanguageDiscrepancyModal'
            ).then(({ default: load }) => load(options, locale));
        },
        priority: 447,
    },
];
